import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {CheckBoxOutlineBlankRounded, CheckBoxRounded} from 'views/icons';
import {Translate} from 'views/module';

const MoreFiltersDropdown = (props) => {
  const {
    options,
    selectedKeys,
    onToggleOption,
  } = props;

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        width: '193px',
        px: '14px',
        pt: '14px',
        pb: '25px',
        pr: '25px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #D9D8D5',
        borderRadius: '4px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '12px',
          width: '154px',
        }}
      >
        <Typography
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '11px',
            lineHeight: '14px',
            color: '#A8A49E',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='loomLead.LoomLeadList.Filter.MoreFilters' />
        </Typography>
        {
          options.map((option) => {
            const isSelected = selectedKeys.includes(option.key);

            return (
              <Box
                key={option.key}
                onClick={() => onToggleOption(option)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
              >
                {
                  isSelected &&
                  <CheckBoxRounded
                    sx={{
                      fontSize: '16px',
                      color: '#DA7955',
                    }}
                  />
                }
                {
                  !isSelected &&
                  <CheckBoxOutlineBlankRounded
                    sx={{
                      fontSize: '16px',
                      color: '#919191',
                    }}
                  />
                }
                <Typography
                  sx={{
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '18px',
                    color: '#000000',
                  }}
                >
                  {option.label}
                </Typography>
              </Box>
            );
          })
        }
      </Box>
    </Box>
  );
};

MoreFiltersDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  selectedKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleOption: PropTypes.func.isRequired,
};

export default React.memo(MoreFiltersDropdown);
